import { useEffect, useState } from 'react'

const QUERY = '(max-width: 767px)'

/**
 * True quando a viewport está em largura de celular (<768px).
 *
 * Único switch entre o layout desktop (intocado) e a UI mobile gameficada.
 * SSR-safe: default false quando window não existe.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(QUERY).matches
  )

  useEffect(() => {
    // App é CSR puro (Vite) — o initializer do useState já leu o valor correto.
    // Aqui só assinamos mudanças de viewport (rotação, resize, devtools).
    const mq = window.matchMedia(QUERY)
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isMobile
}
